module.exports = __webpack_public_path__ + "static/media/silhouette4.237b7cba.jpeg";